module.exports = __webpack_public_path__ + "img/two.1641520899224.png";